// extracted by mini-css-extract-plugin
module.exports = {"root":"_37YN7ZpA9_q7","type_review":"lfZcstelgTxJ","confirmed":"sUJIrGfCVs6A","icon":"_24mFFgp_oEta"};